<template>
  <div style="text-align: left">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <input type="text" style="display:none">
      <el-form-item label="批次">
        <div @dblclick="dblclick('pkgCodeList')">
          <el-input maxlength='450' v-model="formInline.pkgCodeList" placeholder="双击批量搜索"
            @dblclick="dblclick('pkgCodeList')" clearable></el-input>
        </div>
      </el-form-item>
      <el-form-item label="修复人">
        <el-select v-model="formInline.repairer" placeholder="请选择" clearable>
          <el-option v-for="item in repairerList" :key="item.code" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="修复项">
        <el-select v-model="formInline.optionName" placeholder="请输入" clearable>
          <el-option v-for="item in repairOptions" :key="item.name" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="修复时间">
        <el-date-picker v-model="date" :default-time="['', '23:59:59']" type="datetimerange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button style="margin-left: 30px" type="primary" @click="emitSearch()">查询</el-button>
        <el-button style="margin-left: 10px" @click="rest()">重置</el-button>
      </el-form-item>
    </el-form>
    <BatchSearchDialog ref="batchSearchDialog" @search="batchSearch" />
  </div>
</template>

<script>
import BatchSearchDialog from '@/components/BatchSearchDialog/index.vue'
import { formatDate } from "@/utils/timeTool";

export default {
  name: "RepairRecordForm",
  components: {
    BatchSearchDialog,
  },
  props: {
    repairOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      RepairOptionEnum: [],
      formInline: {},
      date: null,
      repairerList: [
        {
          name: '修复人-A',
          code: '修复人-A'
        }, {
          name: '修复人-B',
          code: '修复人-B'
        }, {
          name: '修复人-C',
          code: '修复人-C'
        }
      ]
    };
  },
  async mounted() {
    // const res = await getRepairOptionEnum()
    // this.RepairOptionEnum = res.data
    this.$emit("search", this.formInline);
  },
  mounted() {
    window.addEventListener('keyup', this.handleEnterKey);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handleEnterKey);
  },
  methods: {
    handleEnterKey(event) {
      if (event.key === 'Enter') {
        this.emitSearch();
      }
    },
    dblclick(key) {
      this.$refs.batchSearchDialog.open({ key })
    },
    rest: function () {
      this.formInline = {};
      this.date = null;
      this.$emit("search", this.formInline);
    },
    batchSearch(params) {
      this.formInline = {
        ...this.formInline,
        ...params
      }
      this.emitSearch()
    },
    emitSearch() {
      let params = { ...this.formInline };
      if (this.date) {
        params.repairTimeStart = formatDate(this.date[0].getTime());
        params.repairTimeEnd = formatDate(this.date[1].getTime());
      }
      this.$emit("search", { ...params, pkgCodeList: params.pkgCodeList ? params.pkgCodeList.split(',') : [] });

    },

  },
};
</script>

<style scoped></style>
